/* eslint-disable max-len */
import { createSelector } from 'reselect';
import { USER_MANAGEMENT_ROLE } from '../constants/ApplicationPermissionsConstants';

const getUserManagement = (state) => state.userManagement;

const UserManagementSelectors = {
  makeApplicationManager: createSelector([getUserManagement], (userManagement) =>
    (userManagement.applicationPermissions.users || []).find(
      (user) => user.userManagementRoleString === USER_MANAGEMENT_ROLE.applicationManager,
    ),
  ),
};

export default UserManagementSelectors;
